export var Coupon;
(function (Coupon) {
    /**
     * Add coupon to basket
     */
    let Add;
    (function (Add) {
        Add.path = 'coupon/add';
    })(Add = Coupon.Add || (Coupon.Add = {}));
    /**
     * Remove from basket
     */
    let Remove;
    (function (Remove) {
        Remove.path = 'coupon/remove';
    })(Remove = Coupon.Remove || (Coupon.Remove = {}));
})(Coupon || (Coupon = {}));
